<template>
  <div class="wrapper transition" :class="{ 'collapsed-wrapper': isCollapsed }">
    <Button
      fab
      elevation="2"
      :icon="isCollapsed ? 'mdi-chevron-left' : 'mdi-chevron-right'"
      size="x-small"
      class="collapse-button"
      color="white"
      @click="$emit('collapse')"
    />

    <v-card class="pb-8 px-4 transition" :class="{ collapsed: isCollapsed }">
      <div class="d-flex align-center justify-space-between py-4">
        <p
          class="ma-0 pa-0 subtitle-2 blue-grey--text text--darken-3 font-weight-700"
        >
          {{ $t('home.activity_board.activity_board_title') }}
        </p>
      </div>

      <v-row>
        <v-col
          v-if="hasPotentialImpacts"
          class="mt-4"
          cols="12"
          data-testid="activityBoard-col-potentialImpacts"
        >
          <PotentialFinancialImpacts @empty="hasPotentialImpacts = false" />
        </v-col>

        <v-col
          :class="hasPotentialImpacts ? 'mt-8' : 'mt-4'"
          cols="12"
          data-testid="activityBoard-col-recognitions"
        >
          <Recognitions />
        </v-col>

        <v-col class="mt-8" cols="12" v-if="!hasCompleteProfile">
          <IncompleteProfile />
        </v-col>

        <v-col class="mt-8" cols="12">
          <Challenges />
        </v-col>

        <v-col class="mt-8" cols="12">
          <TopUsers />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Button from '@/components/UI/Button'

import IncompleteProfile from './IncompleteProfile.vue'
import Challenges from './Challenges.vue'
import TopUsers from './TopUsers.vue'
import Recognitions from './Recognitions.vue'
import PotentialFinancialImpacts from './PotentialFinancialImpacts.vue'

export default {
  name: 'ActivityBoard',

  components: {
    Button,
    IncompleteProfile,
    Challenges,
    TopUsers,
    Recognitions,
    PotentialFinancialImpacts,
  },

  props: {
    isCollapsed: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      hasPotentialImpacts: true,
    }
  },

  computed: {
    ...mapGetters(['account']),

    hasCompleteProfile() {
      return this.account.photo && this.account.position
    },
  },
}
</script>

<style lang="scss" scoped>
.transition {
  transition: 200ms ease all;
}

.collapsed {
  user-select: none;
  cursor: default;
  position: absolute;
  right: 0px;
  opacity: 0;
}

.wrapper {
  .collapse-button {
    transition: 100ms ease opacity;
    position: absolute;
    top: 14px;
    left: -4px;
    z-index: 1;
    opacity: 0;
  }

  &:hover {
    .collapse-button {
      opacity: 1;
    }
  }
}

.wrapper.collapsed-wrapper {
  transform: translateX(100%);
}

.wrapper.collapsed-wrapper {
  .collapse-button {
    opacity: 1;
    transition: 200ms ease all;
  }
}
</style>
